var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',[_c('v-card-title',[_vm._v(" ثبت سفارش "),_c('v-spacer'),_c('v-btn',{attrs:{"color":"error","icon":""},on:{"click":function($event){return _vm.closeForm()}}},[_c('v-icon',[_vm._v("mdi mdi-close")])],1)],1),_c('v-divider'),_c('trade-request-form',{ref:"TradeRequestForm"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }